import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=d8ff2b24&scoped=true"
import script from "./ClassEdit.vue?vue&type=script&lang=js"
export * from "./ClassEdit.vue?vue&type=script&lang=js"
import style0 from "./ClassEdit.vue?vue&type=style&index=0&id=d8ff2b24&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ff2b24",
  null
  
)

export default component.exports